var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workspace-content--tab"},[_c('workspace-contents-tab-template',{attrs:{"contents":_vm.contents},on:{"updateList":_vm.updateContents}}),(this.pagination.totalItems)?_c('pagination',{attrs:{"pagination":_vm.pagination}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }